// Wholesale prices are a discount off the list price (e.g. $5 and $10 bags
// sold at 30% off or 50% off). Margin is a share of the selling price.

export const WHOLESALE_DISCOUNTS = [0.3, 0.5] as const

export function wholesalePrice(listPrice: number, discount: number): number {
  return listPrice * (1 - discount)
}

/** Profit and margin share when sold at `price`; null without a cost or price. */
export function marginAt(
  price: number | null,
  cost: number | null,
): { margin: number; pct: number | null } | null {
  if (price == null || cost == null) return null
  const margin = price - cost
  return { margin, pct: price > 0 ? margin / price : null }
}
